export default __webpack_public_path__ + "static/media/restaurant-6-rMIN.e99c5616.jpg";